/**
 * Zod schema for the client → `/api/ingest/crash` payload.
 *
 * Spec authority: `.plan/features/2026-04-24-admin-beta-feedback.md §4.3 + §4.7`
 * Architecture ref: `architecture.md §4.30`.
 *
 * Total payload is capped at 8 kB after server-side sanitisation (§4.7).
 * The server sanitiser truncates `stack` first, then `message` if still over.
 *
 * Pure TS + Zod — no fs / node / DOM imports (package purity invariant).
 */

import { z } from "zod";

export const CrashReportSchema = z
  .object({
    message: z.string().max(4096),
    stack: z.string().max(8192).nullable().optional(),
    source: z.string().max(1024).nullable().optional(),
    line: z.number().int().nonnegative().nullable().optional(),
    col: z.number().int().nonnegative().nullable().optional(),
    url: z.string().max(2048).nullable().optional(),
    app_version: z.string().max(128),
    ua: z.string().max(512),
  })
  .strict();

export type CrashReport = z.infer<typeof CrashReportSchema>;
